/** Какой доступ нужен, чтобы открыть раздел.
 *
 *  Идентификатор раздела и ключ доступа совпадают не всегда, и общая проверка
 *  сравнивала их напрямую:
 *
 *    • «Контроль заказов» открыт двум ролям сразу — продажам и цеху, — а
 *      ключа `sauna-orders` не существует вовсе;
 *    • у анализа звонков раздел зовётся `callAnalytics`, а ключ доступа —
 *      `call_analytics`, через подчёркивание.
 *
 *  Из-за этого оба раздела показывали «нет доступа к этому калькулятору»
 *  всем, кроме администратора: у него проверка прав возвращает true раньше,
 *  чем доходит до сравнения строк, и ошибка не всплывала.
 */
export const SECTION_ACCESS = {
  'sauna-orders': ['sauna_crm', 'sauna_production'],
  callAnalytics: ['call_analytics'],
};

/** Может ли пользователь открыть раздел. `hasAccess` — из AuthContext. */
export const canOpenSection = (sectionId, hasAccess) => {
  if (!sectionId || typeof hasAccess !== 'function') return false;
  const keys = SECTION_ACCESS[sectionId] || [sectionId];
  return keys.some((key) => hasAccess(key));
};

export default canOpenSection;
